import { useSelector } from 'react-redux';
import { authSelectors } from '../../../ducks/auth';

export const useAccountPage = () => {
    const user = useSelector(authSelectors.loggedInUser);

    return {
        username: user?.username || '',
        email: user?.email || '',
    };
};